import {UserService} from '../services';
import {Component} from '@angular/core';

@Component({
  selector: 'app-sidebar-cmp',
  templateUrl: 'sidebar.html',
  styleUrls: ['./sidebar.scss']
})

export class SidebarComponent {

  isActive = false;
  showMenu = '';

  constructor(private userService: UserService) {}

  eventCalled() {
    this.isActive = !this.isActive;
  }

  addExpandClass(element: any) {
    if (element === this.showMenu) {
      this.showMenu = '0';
    } else {
      this.showMenu = element;
    }
  }

  onLoggedout() {
    this.userService.purgeAuth();
  }
}
